import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Forfettario } from 'app/main/forfettario-folder/forfettario.models';

@Injectable({
    providedIn: 'root'
})
export class ForfettarioDataService {
    private upsertEvent = new Subject<Forfettario>();
    public get upsertEvent$() {
        return this.upsertEvent.asObservable();
    }

    constructor() {}

    public sendUpsertEvent(forfettario: Forfettario) {
        this.upsertEvent.next(forfettario);
    }

    public sendUpsertEvents(forfettari: Forfettario[]) {
        forfettari.forEach(forfettario => this.sendUpsertEvent(forfettario));
    }
}
